import React, { useState, useEffect } from 'react';
import '../styles/Collectibleassets.css';
import Apis from '../services/apis';
import {
  LineChart,
  Line,
  ResponsiveContainer,
  Tooltip,XAxis
} from 'recharts';

const CollectibleAssets = () => {
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const apis = new Apis();
  const [categories, setCategories] = useState([]);
  const [Allindices, setAllindices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [cat,setCat] = useState()

  useEffect(() => {

    const fetchData = async () => {
      try {

        let allcat = await getCategories();

        const mapfun =(data)=>
          {
              if(data == "ALL"){
                return "ALL"
              }
              if(data == "NFT"){
                return "NFT"
              }
              if(data == "ART"){
                return "ART"
              }
              if(data == "COLLECTIBLES"){
                return "SECURITIZED COLLECTIBLES"
              }
              if(data == "WATCHES"){
                return "LUXURY TIMEPIECES"
              }
              if(data == "CARS"){
                return "EXOTIC AUTOMOBILES"
              }
              if(data=="HANDBAGS"){
                return "DESIGNER HANDBAGS"
              }
              else{
                return data
              }
          }
          const categoryMap = allcat.reduce((acc, c) => {
            acc[mapfun(c.code.replaceAll("_"," "))] = c;
            return acc;
          }, {});
          // console.log("cmap===",categoryMap)


          
        const response = await apis.getIndices();
        const stories = response.data.indices;
        const normalizedStories = stories.map(story => {
          let ncat = story.category
          ? story.category.trim().toLowerCase()
          : 'uncategorized';
          ncat = mapfun(ncat?.toUpperCase())
          return ({
          ...story,
          category: ncat,
          categoryColor: categoryMap[ncat]?.color || '#CCCCCC',

        })});

        // console.log("ns===",normalizedStories)



        setAssets(normalizedStories);
        setAllindices(normalizedStories);
        const map = {};
        normalizedStories.forEach(s => {
          map[s.category] = (map[s.category] || 0) + 1;
        });

        setCategories([
          { id: 'all', name: 'All', count: normalizedStories.length },
          ...Object.entries(map).map(([key, count]) => ({
            id: key,
            name: key.charAt(0).toUpperCase() + key.slice(1),
            count,
            categoryColor: categoryMap[key]?.color || '#CCCCCC',
          })),
        ]);

        

      } catch (error) {
        if (error.response?.status === 404) {
          alert("Error occurred while fetching categories " + error.response.data.message);
        } else {
          console.error("Error:", error);
          alert("Error occurred while fetching asset data");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // const getCategories = async() => {
  //   apis.getCategories()
  //   .then((response) => {
  //       let data = response.data
  //       return data;
  //   })
  //   .catch((error) => {
  //       if (error.response && error.response.status === 404) {
  //           alert("Error occurred while fetching categories "+ error.response.data.message);
  //       } else {
  //           // Handle other errors
  //           console.error("Error:", error);
  //           alert("Error occurred while fetching asset data");
  //       }
  //   });
  // }

  const getCategories = async () => {
    try {
      const response = await apis.getCategories();
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        alert("Error occurred while fetching categories " + error.response.data.message);
      } else {
        console.error("Error:", error);
        alert("Error occurred while fetching asset data");
      }
      return [];
    }
  };

  useEffect(() => {
    if (selectedCategory === 'all') {
      setAssets(Allindices);
    } else {
      setAssets(
        Allindices.filter(i => i.category === selectedCategory)
      );
    }
  }, [selectedCategory, Allindices]);

 

  const formatChange = (value) => {
    const num = parseFloat(value);
    return num >= 0 ? `+${num.toFixed(2)}%` : `${num.toFixed(2)}%`;
  };

  const getChangeClass = (value) => {
    return parseFloat(value) >= 0 ? 'positive' : 'negative';
  };
  
  const getChangeColor = (value) =>
    value >= 0 ? '#4ade80' : '#f87171';
  

  // const sparklineData = (asset)=>{
  //   let arr = [];
  //   asset.priceHistory.map((item)=>{
  //     arr.push({ name: item.event_date, value: item.value_close })
  //   })
  //   return arr;

  // //   return[
  // //   { name: '90d', value: Number(asset.profile.change_90d) },
  // //   { name: '30d', value: Number(asset.profile.change_30d) },
  // //   { name: '7d', value: Number(asset.profile.change_7d) },
  // // ]
  // };

  const sparklineData = (asset) => {
    if (!asset?.priceHistory?.length) return [];
  
    return( 
    // [...asset.priceHistory]
    asset.priceHistory.sort((a, b) => new Date(a.event_date) - new Date(b.event_date))
      .slice(-30)
      .map(item => ({
        name: item.event_date,
        value: item.value_open,
      })))
  };

  const map =(data)=>
    {
        if(data == "ALL"){
          return "ALL"
        }
        if(data == "NFT"){
          return "NFT"
        }
        if(data == "ART"){
          return "ART"
        }
        if(data == "COLLECTIBLES"){
          return "SECURITIZED COLLECTIBLES"
        }
        if(data == "WATCHES"){
          return "LUXURY TIMEPIECES"
        }
        if(data == "CARS"){
          return "EXOTIC AUTOMOBILES"
        }
        if(data=="HANDBAGS"){
          return "DESIGNER HANDBAGS"
        }
        else{
          return data
        }
    }

 
  if (loading) {
    return (
      <div style={{
        height: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div
          style={{
            width: '80px',
            height: '80px',
            border: '10px solid rgba(255,255,255,0.2)',
            borderTop: '10px solid #F4A31E',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}
        />
      </div>
    );
  }

  return ( 
    <div className="collectible-assets-container">
      <div className="header">
      <h2 className="news-title">Indices</h2>
      <p className="subtitle">Price indices of secondary markets for luxury brands</p>
      </div>

      <div className="category-filters">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`filter-btn ${selectedCategory === cat.id ? 'active' : ''}`}
              style={{fontSize:12,
                ...selectedCategory != cat.id&&{
                backgroundColor: `${cat.categoryColor}22`,
                color: cat.categoryColor,
                borderColor: `${cat.categoryColor}`,
              }}}
              onClick={() => {
                // setAssets([]);
                setSelectedCategory(cat.id)
                // let arr = Allindices.filter( i => i.category === cat.id)  
                // if(cat.id === 'all'){
                //   arr = Allindices
                // }
                // console.log(arr)
                // setAssets(arr)    
              }}
            >
              {map(cat.name?.toUpperCase())}
              <span className="filter-count" style={{...selectedCategory != cat.id&&{color:cat.categoryColor}}}>{cat.count}</span>
            </button>
          ))}
        </div>


      <div className="assets-grid">
        {assets.map((asset) => (
          <div key={asset.ticker} className="asset-card">
            <div className="asset-ticker">{asset.ticker}</div>
            <div className="asset-name">{asset.name}</div>
            
            <div className={`change-main ${getChangeClass(asset.profile.change_30d)}`}>
              {formatChange(asset.profile.change_30d)}
            </div>
            <div className="change-period">30 DAY CHANGE</div>

            {/* <div className="chart-container">
              <svg width="200" height="60" viewBox="0 0 200 60">
                <polyline
                  points={generateChartPath(asset.profile.change_30d, asset.profile.change_7d, asset.profile.change_90d)}
                  className={`chart-line ${getChangeClass(asset.profile.change_30d)}`}
                />
              </svg>
            </div> */}

              <div className="chart-container">
                <ResponsiveContainer width={200} height={60}>
                  <LineChart data={sparklineData(asset)}>
                    {/* <Line
                      type="monotone"
                      dataKey="value"
                      stroke={getChangeColor(asset.profile.change_30d)}
                      strokeWidth={2}
                      dot={false}
                    /> */}
                  <XAxis dataKey="name" hide />

                    {/* <defs>
                      <linearGradient id={`lineGrad-${asset.id}`} x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stopColor={getChangeColor(asset.profile.change_30d)} />
                        <stop offset="100%" stopColor={getChangeColor(asset.profile.change_30d)} />
                      </linearGradient>
                    </defs> */}

                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke={getChangeColor(asset.profile.change_30d)}
                      strokeWidth={2}
                      dot={false}
                    />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: '#020617',
                        border: '1px solid #1e293b',
                        borderRadius: '8px',
                        fontSize: '12px',
                        color: '#e5e7eb',
                      }}
                      labelFormatter={(label) => label}
                      formatter={(v) => `${v}`}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>

            <div className="change-details">
              <div className="change-detail">
                <div className={`change-value ${getChangeClass(asset.profile.change_7d)}`}>
                  {formatChange(asset.profile.change_7d)}
                </div>
                <div className="change-label">7 DAY</div>
              </div>
              <div className="change-detail">
                <div className={`change-value ${getChangeClass(asset.profile.change_90d)}`}>
                  {formatChange(asset.profile.change_90d)}
                </div>
                <div className="change-label">90 DAY</div>
              </div>
            </div>
            {/* <div className="asset-ticker" style={{marginTop:30}}>
              <span style={{padding:10,border:'1px solid orange',borderRadius:12,fontSize:10}}>
                {map(asset.category?.toUpperCase())}
              </span>
            </div> */}

                {/* <div className="card-footer" style={{marginTop:30,}}>
                  <span className="card-index">{map(asset.category?.toUpperCase())}</span>
                </div> */}


            <div
              className="category-badge"
              style={{
                marginTop:'15px',
                // backgroundColor: `#141414`,
                // backgroundColor: `rgba(255, 255, 255, 0.1)`,
                backgroundColor: `${asset.categoryColor}22`,
                color: asset.categoryColor,
                borderColor: `${asset.categoryColor}`
              }}
            >
          
              <span style={{color:`${asset.categoryColor}`}}>{asset.category}</span>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default CollectibleAssets;